import { ofType } from 'redux-observable'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import {
  actionTypes,
  generateUigpOtpActionFailure,
  generateUigpOtpActionSuccess,
  getChangeMobileSecurityQuestionsActionFailure,
  getChangeMobileSecurityQuestionsActionSuccess,
  verifyChangeMobileCaOtpActionFailure,
  verifyChangeMobileCaOtpActionSuccess,
  verifyChangeMobileEmailOtpActionFailure,
  verifyChangeMobileEmailOtpActionSuccess,
  verifyChangeMobileSecurityQuestionsActionFailure,
  verifyChangeMobileSecurityQuestionsActionSuccess,
  verifyUigpOtpActionFailure,
  verifyUigpOtpActionSuccess,
} from './actions'
import {
  generateUigpOtpService,
  getSecurityQuestionsChangeMobileService,
  verifyCaAuthenticatorOtpChangeMobileService,
  verifyEmailOtpChangeMobileService,
  verifySecurityQuestionsChangeMobileService,
  verifyUigpOtpService,
} from './services'

// Generate UIGP OTP
const generateUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GENERATE_UIGP_OTP),
    mergeMap((action: any) =>
      generateUigpOtpService(action.payload).pipe(
        map((response: any) => generateUigpOtpActionSuccess(response)),
        catchError((error: any) => of(generateUigpOtpActionFailure(error)))
      )
    )
  )

const verifyUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_UIGP_OTP),
    mergeMap((action: any) =>
      verifyUigpOtpService(action.payload).pipe(
        map((response: any) => verifyUigpOtpActionSuccess(response)),
        catchError((error: any) => of(verifyUigpOtpActionFailure(error)))
      )
    )
  )

const verifyEmailOtpChangeMobileEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP),
    mergeMap((action: any) =>
      verifyEmailOtpChangeMobileService(action.payload).pipe(
        map((response: any) =>
          verifyChangeMobileEmailOtpActionSuccess(response)
        ),
        catchError((error: any) =>
          of(verifyChangeMobileEmailOtpActionFailure(error))
        )
      )
    )
  )

// Get security questions
const getSecurityQuestionsChangeMobileEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CHANGE_MOBILE_SEC_QUESTIONS),
    mergeMap(() =>
      getSecurityQuestionsChangeMobileService().pipe(
        map((response: any) =>
          getChangeMobileSecurityQuestionsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(getChangeMobileSecurityQuestionsActionFailure(error))
        )
      )
    )
  )

const verifySecurityQuestionsChangeMobileEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS),
    mergeMap((action: any) =>
      verifySecurityQuestionsChangeMobileService(action.payload).pipe(
        map((response: any) =>
          verifyChangeMobileSecurityQuestionsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(verifyChangeMobileSecurityQuestionsActionFailure(error))
        )
      )
    )
  )

// Verify mobile otp ca mobile
const verifyCaAuthenticatorOtpChangeMobileEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR),
    mergeMap((action: any) =>
      verifyCaAuthenticatorOtpChangeMobileService(action.payload).pipe(
        map((response: any) => verifyChangeMobileCaOtpActionSuccess(response)),
        catchError((error: any) =>
          of(verifyChangeMobileCaOtpActionFailure(error))
        )
      )
    )
  )

const epics = [
  generateUigpOtpEpic,
  verifyUigpOtpEpic,
  getSecurityQuestionsChangeMobileEpic,
  verifySecurityQuestionsChangeMobileEpic,
  verifyEmailOtpChangeMobileEpic,
  verifyCaAuthenticatorOtpChangeMobileEpic,
]

export default epics
